module.exports = __webpack_public_path__ + "img/icon_next-gl.dab989da.svg";